import { AB_USERINFO_SET } from "@/constants/ABMng";
import useAppStore from "@/context/store";
import { getGdUserOrgs, sessionExchangeRedirect, switchOrg } from "@/services";
import { getExpsValue } from "@/tracker/abTest";
import dayjs from "dayjs";
import { getAccessToken } from "./auth";
import { gaodingUmsHost } from "./host";
import { checkLogin } from "./open";

export function isGdMerged(user: IUser) {
  return (
    Boolean(getOrgIdByUser(user)) ||
    (Boolean(user?.extra?.uc_id) &&
      typeof window !== "undefined" &&
      sessionStorage.getItem("mergeState") !== "1")
  );
}

export function getOrgIdByUser(user: IUser) {
  return user?.extra?.org_id;
}

/**终身会员判断 */
export function isPermanentlyVip(expireDate: number | string | Date) {
  return dayjs(expireDate).diff(dayjs(), "year") > 50;
}

/**
 * 获取当前有效期文案
 * @param expireDate 过期时间
 * @returns YYYY-MM-DD 到期 / 终身有效
 */
export function getExpireDateTxt(expireDate: number | string | Date) {
  if (!expireDate) return "";

  if (new Date(expireDate).getTime() < new Date().getTime()) {
    return `会员已于 ${dayjs(expireDate).format("YYYY-MM-DD")} 到期`;
  }

  return isPermanentlyVip(expireDate)
    ? "终身有效"
    : `${dayjs(expireDate).format("YYYY-MM-DD")} 到期`;
}

// 全局变量，用于确定只会有一次处理过程
let handlePromise: Promise<boolean> = null;
/**
 * 遇到用户不在租户里的处理函数
 * 处理逻辑：查询当前用户所有租户，然后自动切换到第一个租户
 * 接口返回如下错误信息时， 做此处理：code: "10010412"  message: "用户不在租户里"
 */
export async function handleUserNotInOrg() {
  if (handlePromise) {
    return handlePromise;
  }

  async function switchFn() {
    const orgs = await getGdUserOrgs();

    if (orgs.length > 0) {
      const user = useAppStore.getState().user;
      const orgId = getOrgIdByUser(user);

      // orgId在orgs中， 则自动切换到orgId
      if (orgId && orgs.find((org) => org.org_id === orgId)) {
        const res = await switchOrg(orgId);
        // 重置变量
        handlePromise = null;

        useAppStore.getState().refreshUser();

        return !res.err;
      }

      // 自动切换到第一个组织
      const res = await switchOrg(orgs[0].org_id);
      // 重置变量
      handlePromise = null;

      useAppStore.getState().refreshUser();

      return !res.err;
    } else {
      handlePromise = null;
      // 当前用户不存在租户
      return false;
    }
  }

  handlePromise = switchFn();

  return handlePromise;
}

export async function openSettingPage(
  user: IUser,
  {
    target,
    query,
    page,
  }: {
    target?: string;
    query?: string;
    page?: "userInfo" | "account" | "system";
  } = {
    target: "_blank",
    query: "",
    page: "userInfo",
  }
) {
  const path = {
    userInfo: "/settings",
    account: "/settings/account",
    system: "/settings/system",
  }[page];

  // 未登录去登录
  if (!user) {
    user = await checkLogin();
  }

  // 已合并用户，需要判断是否是session登录还是token登录
  if (user?.extra?.uc_id) {
    const abValue = await getExpsValue(
      AB_USERINFO_SET.variableName,
      AB_USERINFO_SET.defaultValue
    );

    if (AB_USERINFO_SET.map.old.includes(abValue)) {
      // AB旧版本，跳转到旧版设置页
      window.open(`/settings?${query || ""}`, target);
      return;
    }
    const token = await getAccessToken();
    if (!token) {
      // session登录用户，需要session换token，然后重定向到一体化设置页
      sessionExchangeRedirect(`https://${gaodingUmsHost}/ums/cgi${path}`);
    } else {
      window.open(`https://${gaodingUmsHost}/ums/cgi${path}`, target);
    }
  } else {
    window.open(`/settings?${query || ""}`, target);
  }
}
